import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import Settings from './Settings';
import Auth from './Auth';
import Common from './Common';
import Resource from './Resource';
import Role from './Role';
import User from './User';
import Client from './Client';
import Location from './Location';
import Asset from './Asset';
import AssetType from './AssetType';
import EquipmentSubType from './EquipmentSubType';
import Vendor from './Vendor';
import Document from './Document';
import DocumentType from './DocumentType';
import Manpower from './Manpower';
import SparePartType from './SparePartType';
import SparePartTransaction from './SparePartTransaction';
import JobCard from './JobCard';
import AssetTransferAdvice from './AssetTransferAdvice';
import AssetService from './AssetService';
import AssetReceiptNote from './AssetReceiptNote';
import PurchaseOrder from "./PurchaseOrder";
import SaleOrder from "./SaleOrder";
import SubAssetTransfer from "./SubAssetTransfer";
import Owner from "./Owner";
import JobType from "./JobType";
import ManpowerPerformance from "./ManpowerPerformance";
import Interval from "./Interval";
import AssetRefurbishTransaction from "./AssetRefurbishTransaction";
import UnitOfMeasurement from "./UnitOfMeasurement";
import SparePart from "./SparePart";
import SpareTransferAdvice from './SpareTransferAdvice';
import SpareReceiptAdvise from './SpareReceiptAdvise';
import Complaint from "./Complaint";
import Activity from "./Activity";
import JobCardAllocation from "./JobCardAllocation";
import ActivityType from "./ActivityType";
import JobCardStatusUpdate from "./JobCardStatusUpdate";
import JobCardClosure from "./JobCardClosure";
import Log from "./Log";
import SparesIssue from "./SparesIssue";
import Status from "./Status";
import JobCardStatus from "./JobCardStatus";
import Organisation from "./Organisation";
import AssetStockTaking from "./AssetStockTaking";
import FuelType from './FuelType';
import FuelReadingMethod from './FuelReadingMethod';
import FuelLevelReading from './FuelLevelReading';
import FleetTrip from './FleetTrip';
import Fuel from './Fuel';
import QrScanLog from "./QrScanLog";
import ConditionOfAsset from './ConditionOfAsset';
import EmployeeAssetIssue from "./EmployeeAssetIssue";
import EmployeeAssetReceipt from "./EmployeeAssetReceipt";
import AssetModel from "./AssetModel";
import POReport from "./POReport";
import Labour from './Labour';
import ThirdPartyWorkRequirement from "./ThirdPartyWorkRequirement";
import ThirdPartyWorkQuotation from "./ThirdPartyWorkQuotation";
import ThirdPartyWorkApproval from "./ThirdPartyWorkApproval";
import ThirdPartyWorkOrderUpdate from "./ThirdPartyWorkOrderUpdate";
import ActivityClosure from "./ActivityClosure";
import InvoiceEntry from "./InvoiceEntry";
import Event from "./Event";
import Notification from "./Notification";
import SpareInventoryReport from "./SpareInventoryReport";
import PreVerification from './PreVerification';
import PreVerificationApproval from "./PreVerificationApproval";
import NotificationSetting from "./NotificationSetting";
import StockMethod from "./StockMethod";
import FuelStatus from "./FuelStatus";
import Leasing from "./Leasing";
import Contract from "./Contract";
import AssetMake from "./AssetMake";
import DocumentRenewal from "./DocumentRenewal";
import SparePartAttribute from "./SparePartAttribute";
import SubAssembly from "./SubAssembly";
import Task from './Task';
import ServiceIdentifier from './ServiceIdentifier';
import PreventiveMaintenance from "./PreventiveMaintenance";
import TaskComponent from "./TaskComponent";
import TaskAction from "./TaskAction";
import ManpowerReminder from "./ManpowerReminder";
import AssetLink from "./AssetLink";
import AssetTagType from "./AssetTagType";
import AssetTagAttribute from "./AssetTagAttribute";
import AssetClassification from "./AssetClassification";
import OrganisationType from "./OrganisationType";
import AssetManager from "./AssetManager";
import PageSetting from "./PageSetting";
import Attendance from "./AttendanceManpower";
import AuditVoucher from './AuditVoucher';
import FuelAdjustment from './FuelAdjustment';
import Reconciliation from './Reconciliation';
import ManualAssetReading from './ManualAssetReading';
import AssetFuelSensorCalibration from './AssetFuelSensorCalibration';
import IotDevice from './IotDevice';
import Meter from './Meter';
import AssetReading from './AssetReading';
import ExternalRequestLog from './ExternalRequestLog';
const reducers = combineReducers({
  routing: routerReducer,
  settings: Settings,
  auth: Auth,
  commonData: Common,
  resource: Resource,
  role: Role,
  user: User,
  client: Client,
  location: Location,
  asset: Asset,
  assetType: AssetType,
  equipmentSubType: EquipmentSubType,
  vendor: Vendor,
  document: Document,
  documentType: DocumentType,
  manpower: Manpower,
  sparePartType: SparePartType,
  sparePartTransaction: SparePartTransaction,
  spareInventory: SpareInventoryReport,
  jobCard: JobCard,
  assetTransferAdvice: AssetTransferAdvice,
  assetService: AssetService,
  assetReceiptNote: AssetReceiptNote,
  purchaseOrder: PurchaseOrder,
  saleOrder: SaleOrder,
  subAssetTransfer: SubAssetTransfer,
  owner: Owner,
  jobType: JobType,
  manpowerPerformance: ManpowerPerformance,
  interval: Interval,
  assetRefurbishedTransaction: AssetRefurbishTransaction,
  unitOfMeasurement: UnitOfMeasurement,
  sparePart: SparePart,
  spareTransferAdvice: SpareTransferAdvice,
  spareReceiptAdvise: SpareReceiptAdvise,
  complaint: Complaint,
  activity: Activity,
  jobCardAllocation: JobCardAllocation,
  activityType: ActivityType,
  jobCardStatusUpdate: JobCardStatusUpdate,
  jobCardClosure: JobCardClosure,
  log: Log,
  sparesIssue: SparesIssue,
  status: Status,
  jobCardStatus: JobCardStatus,
  organisation: Organisation,
  assetStockTaking: AssetStockTaking,
  fuelType: FuelType,
  fuelReadingMethod: FuelReadingMethod,
  fuelLevelReading: FuelLevelReading,
  fleetTrip: FleetTrip,
  fuel: Fuel,
  qrScanLog: QrScanLog,
  conditionOfAsset: ConditionOfAsset,
  employeeAssetIssue: EmployeeAssetIssue,
  employeeAssetReceipt: EmployeeAssetReceipt,
  assetModel: AssetModel,
  poReport: POReport,
  spareInventoryReport: SpareInventoryReport,
  labour: Labour,
  thirdPartyWorkRequirement: ThirdPartyWorkRequirement,
  thirdPartyWorkQuotation: ThirdPartyWorkQuotation,
  thirdPartyWorkApproval: ThirdPartyWorkApproval,
  thirdPartyWorkOrderUpdate: ThirdPartyWorkOrderUpdate,
  invoiceEntry: InvoiceEntry,
  activityClosure: ActivityClosure,
  event: Event,
  notification: Notification,
  preVerification: PreVerification,
  preVerificationApproval: PreVerificationApproval,
  stockMethod: StockMethod,
  fuelStatus: FuelStatus,
  notificationSetting: NotificationSetting,
  leasing: Leasing,
  contract: Contract,
  assetMake: AssetMake,
  documentRenewal: DocumentRenewal,
  sparePartAttribute: SparePartAttribute,
  subAssembly: SubAssembly,
  task: Task,
  serviceIdentifier: ServiceIdentifier,
  preventiveMaintenance: PreventiveMaintenance,
  taskComponent: TaskComponent,
  taskAction: TaskAction,
  manpowerReminder: ManpowerReminder,
  assetLink: AssetLink,
  assetTagType: AssetTagType,
  assetTagAttribute: AssetTagAttribute,
  assetClassification: AssetClassification,
  organisationType: OrganisationType,
  assetManager: AssetManager,
  pageSetting: PageSetting,
  manpowerAttendance: Attendance,
  auditVoucher: AuditVoucher,
  fuelAdjustment: FuelAdjustment,
  reconciliation: Reconciliation,
  manualAssetReading: ManualAssetReading,
  assetFuelSensorCalibration: AssetFuelSensorCalibration,
  iotDevice: IotDevice,
  meter: Meter,
  assetReading: AssetReading,
  externalRequestLog: ExternalRequestLog,
});
export default reducers;

